import { useAssignSetting, useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { BATCH_7_SIGNUP_MODAL_CTA_250212 } from "@faire/web-api--source/indigofair/settings/BATCH_7_SIGNUP_MODAL_CTA_250212";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";
export var useSettingSignupCta = function() {
    return useSetting(BATCH_7_SIGNUP_MODAL_CTA_250212, IFourVariantXP.Bucket.CONTROL);
};
export var useAssignSettingSignupCta = function() {
    return useAssignSetting(BATCH_7_SIGNUP_MODAL_CTA_250212);
};
